import { Box, Link as MuiLink, Typography } from "@mui/material";
import { Fragment } from "react";

interface ExternalLinksProps {
  links: { href: string; text: string }[];
}

export const ExternalLinks = ({ links }: ExternalLinksProps) => {
  return (
    <Box alignItems="center" display="flex" gap="0.25rem" justifyContent="center">
      {links.map(({ href, text }, index) => (
        <Fragment key={text}>
          {index !== 0 && (
            <Typography color="primary" variant="caption">
              ·
            </Typography>
          )}
          <MuiLink
            color="text.primary"
            href={href}
            key={text}
            rel="noopener noreferrer"
            target="_blank"
            variant="caption"
          >
            {text}
          </MuiLink>
        </Fragment>
      ))}
    </Box>
  );
};
